import { OrderStatus as AtlasOrderStatus } from '__generated__/atlas-types'

export const shouldModalOpen = (
  isProBrand: boolean,
  isLiteRetailer: boolean,
  newStatus: AtlasOrderStatus,
) => {
  const applicableStatuses = [
    AtlasOrderStatus.NOTES,
    AtlasOrderStatus.PENDING,
    AtlasOrderStatus.APPROVED,
  ]
  if (isProBrand) {
    return [AtlasOrderStatus.SHIPPED, ...applicableStatuses].includes(newStatus)
  }
  if (isLiteRetailer) {
    return applicableStatuses.includes(newStatus)
  }
}
